import search from './search.hbs';
import './search.scss'

export default () => search()
